export default __webpack_public_path__ + "static/media/fast-delivery-disabled.7fb18064.svg";